"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M8 0L0 16h16L8 0zM7 5l5 10H2L7 5z"];
//# sourceMappingURL=delta.js.map